import { render, staticRenderFns } from "./beneficiary.vue?vue&type=template&id=46589bdb&scoped=true&"
import script from "./beneficiary.vue?vue&type=script&lang=js&"
export * from "./beneficiary.vue?vue&type=script&lang=js&"
import style0 from "./beneficiary.vue?vue&type=style&index=0&id=46589bdb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46589bdb",
  null
  
)

export default component.exports